import { createRoutine } from 'redux-saga-routines';
import { action } from 'typesafe-actions';
import { Props } from '.';

export const routine = createRoutine('FULL_REGISTRATION/VERIFICATION');
export const codeRoutine = createRoutine('FULL_REGISTRATION/VERIFICATION/CODE_SEND');

export const ACTIVATE = 'REGISTRATION_VERIFICATION_STEP/ACTIVATE';
export const DEACTIVATE = 'REGISTRATION_VERIFICATION_STEP/DEACTIVATE';

export const lifecycle = {
  activate: (props: Props) => action(ACTIVATE, props),
  deactivate: () => action(DEACTIVATE),
};
